import { render, staticRenderFns } from "./FQA.vue?vue&type=template&id=f6e4be98&scoped=true"
import script from "./FQA.js?vue&type=script&lang=js&external"
export * from "./FQA.js?vue&type=script&lang=js&external"
import style0 from "./FQA.vue?vue&type=style&index=0&id=f6e4be98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e4be98",
  null
  
)

export default component.exports